import { FC, useEffect, useState } from 'react'
import { DateTime } from 'luxon'
import { Button, Separator, Text } from '@/ui'
import { listLastRanOnDate } from './actions'
import SmartRuleCreationModal from './SmartRuleCreationModal'
import { UserTransactionRulesTable } from './UserTransactionRulesTable'
import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { TextColors, TypographyStyles } from '@/styles'

interface props {
  user: UserWithAdminInfo
}

export const SmartRuleCreation: FC<props> = ({ user }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [lastRanOn, setLastRanOn] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      const response = await listLastRanOnDate(user.id)
      if (response) {
        setLastRanOn(response.smartRuleLastRan)
      }
    }
    fetchData()
  }, [user.id])
  return (
    <div id="smartRuleCreation">
      <Button
        variant="primary"
        onClick={() => setModalOpen(true)}
        disabled={
          DateTime.fromISO(lastRanOn) > DateTime.now().minus({ days: 2 })
        }
      >
        Run Smart Rule Creation
      </Button>
      <div className="mt-4">
        <Text variant={TypographyStyles.BODY_MD} color={TextColors.MUTED}>
          Last ran on:{' '}
          {DateTime.fromISO(lastRanOn).toFormat(
            DATE_FORMATS_LUXON.DISPLAY_SHORT
          )}
        </Text>
        <br />
        <Text variant={TypographyStyles.BODY_MD} color={TextColors.MUTED}>
          Note: You can only run Smart Rule creation every 3 days. This allows
          the new rules you have created to go into effect, so that we do not
          create duplicate rules.
        </Text>
      </div>
      <Separator />
      <br />
      <UserTransactionRulesTable user={user} />

      <SmartRuleCreationModal
        open={modalOpen}
        close={() => setModalOpen(false)}
        user={user}
      />
    </div>
  )
}
